__turbopack_context__.v({
  "languageStyle": "Code-module__utbJbG__languageStyle",
  "style": "Code-module__utbJbG__style",
  "styledPre": "Code-module__utbJbG__styledPre",
});
